import { SVGProps } from 'react';

export default function ModularBlowerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <rect x='5.25' y='3' width='13.5' height='18' rx='1.5' />
      <circle cx='11.25' cy='13.5' r='3.75' />
      <circle cx='11.25' cy='13.5' r='0.75' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M11.25 9.75h5.25v3.75'
      />
    </svg>
  );
}
